import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { NotificationService } from '../services/notification.service';
import { UploadedFileViewModel } from '../../../components/uploader/document_uploader.types';

@Injectable()
export class DocumentInterceptorService implements HttpInterceptor {
    constructor(private notificationService: NotificationService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError(error => {
                if (error instanceof HttpErrorResponse && error.status === 401) {
                    if (request.body instanceof UploadedFileViewModel) {
                        this.notificationService.addErrorMessage('Error al descargar el adjunto al contenido');
                    }
                }

                return throwError(() => error);
            }),
        );
    }
}
